import { LoginModal } from '@/app/_modals/LoginModal';
import { RegisterModal } from '@/app/_modals/RegisterModal';
import { ModalProps, UrlModalData } from '@/shared/types';

/** Modals that open from the URL (`?modal=login`), passed to `ModalProvider` by the root layout. */
export const URL_MODAL_REGISTRY: Record<string, React.ComponentType<ModalProps<UrlModalData>>> = {
    login: LoginModal,
    register: RegisterModal,
};
